import { FC, useState } from 'react';
import { useProductCommentsQuery } from './ApiRequests';
import styles from './Comments.module.css';
import buttonsStyles from '../../buttons.module.css';
import { CommentProps } from './Types';
import { StarScore } from "../StarScore";
import { ThumbUp } from '../../svg/ThumbUp';
import { ThumbDown } from '../../svg/ThumbDown';

const Comment: FC<{ commentProps: CommentProps }> = ({ commentProps }) => {
    return (
        <div className={styles.comment}>
            <div className={styles.userPanel}>
                <div className={styles.user}>
                    <img src={commentProps.avatarImgScr} alt="avatar" />
                    <span>{commentProps.username}</span>
                </div>
                <span>{commentProps.addDate}</span>
            </div>
            <div className={styles.content}>
                <div className={styles.header}>
                    <StarScore score={commentProps.score} starCount={10} />
                    <span>{commentProps.addTimeToServerTimeDiffrenceText}</span>
                </div>
                <div className={styles.body}>
                    {commentProps.commentText}
                </div>
                <div className={styles.footer}>
                    <span>This opinion was helpful?</span>
                    <button>
                        <ThumbUp />
                    </button>
                    <span>{commentProps.helpfullCommentCount}</span>
                    <button>
                        <ThumbDown />
                    </button>
                    <span>{commentProps.unhelpfulCommentCount}</span>
                </div>
            </div>
        </div>
    );
}


export const CommentsPanel: FC<{ productId: number }> = ({ productId }) => {
    const [pageIndex, setPageIndex] = useState(1);
    const productCommentsQuery = useProductCommentsQuery(productId, pageIndex);

    if (productCommentsQuery.isLoading) {
        return <span>Loading...</span>
    }

    if (productCommentsQuery.isError) {
        return <span>Error: {productCommentsQuery.error.message}</span>
    }

    const loadNextComments = () => {
        setPageIndex(pageIndex + 1);
    }

    const loadPreviousComments = () => {
        setPageIndex(pageIndex - 1);
    }

    // todo below replace pageIndex with productCommentsQuery.data.pageIndex, when api will be written
    return (
        <div className={styles.commentsPanel}>
            <h2>User Opinions <span>({productCommentsQuery.data.allCommentsCount})</span></h2>
            <hr />
            <span>Results: {(pageIndex * productCommentsQuery.data.pageSize) - productCommentsQuery.data.pageSize} - {pageIndex * productCommentsQuery.data.pageSize} of {productCommentsQuery.data.allCommentsCount} </span>
            <hr />
            {
                productCommentsQuery.data.comments.map((comment) => {
                    return (
                        <div key={comment.id}>
                            <Comment commentProps={comment} />
                            <hr />
                        </div>
                    )
                })
            }
            <div className={styles.pagining}>
                <span>Page:</span>
                {pageIndex > 1 && <button className={buttonsStyles.btnPrimary} onClick={loadPreviousComments}>{pageIndex - 1}</button>}
                <button className={buttonsStyles.btnSecondary}>{pageIndex}</button>
                {pageIndex * productCommentsQuery.data.pageSize < productCommentsQuery.data.allCommentsCount && <button className={buttonsStyles.btnPrimary} onClick={loadNextComments}>{pageIndex + 1}</button>}
            </div>
        </div>
    );
}
